// ═══════════════════════════════════════════════════════════════════
//  modules/documents/constantes.js
//  DOC_CATEGORIES · DOC_CAT_LABELS · DOC_STATUTS · DOC_RECURRENCES · REC_LABELS · REC_MONTHLY · DOC_FILE_CATEGORIES · DOC_FILE_CAT_LABELS
// ═══════════════════════════════════════════════════════════════════

// ═══════════════════════════════════════════════════════════════════════
//  MODULE DOCUMENTS — COMPLET (6 sous-modules)
//  À coller dans App.js juste AVANT  `function Dashboard(...)`.
//  (Si tu avais déjà collé le bloc 3a, REMPLACE-le par celui-ci.)
//  Aucun nouvel import : réutilise THEME, API_BASE, useState, useEffect, useRef.
//
//  ───────────────────────────────────────────────────────────────────────
//  CONTRAT D'API attendu côté server.js (étape 4) :
//
//  Compta
//    GET    /api/documents/transactions
//    POST   /api/documents/transactions
//    PUT    /api/documents/transactions/:id
//    DELETE /api/documents/transactions/:id
//    GET    /api/documents/members              -> [{ id, pseudo }]
//    GET    /api/documents/compta/export.xlsx   -> fichier .xlsx
//
//  Cloud officiel
//    GET    /api/documents/files?q=&categorie=&statut=
//    POST   /api/documents/files                (multipart, champ "file") -> ligne créée + classement IA
//    PUT    /api/documents/files/:id            (categorie, tags, resume, statut)
//    POST   /api/documents/files/:id/reclassify -> relance l'IA
//    GET    /api/documents/files/:id/download   -> fichier
//    DELETE /api/documents/files/:id            -> corbeille
//
//  CRUD simples (mêmes verbes GET/POST/PUT/DELETE) :
//    /api/documents/contrats
//    /api/documents/domaines
//    /api/documents/marques
//    /api/documents/comptes-rendus
//    /api/documents/merch
// ═══════════════════════════════════════════════════════════════════════

// ── Constantes ──────────────────────────────────────────────────────────
export const DOC_CATEGORIES = ["hebergement","domaine","plugin","prestataire","juridique","graphisme","boutique","dons","pack_fondateur","merch","divers"];

export const DOC_CAT_LABELS = { hebergement:"Hébergement", domaine:"Domaine", plugin:"Plugin", prestataire:"Prestataire", juridique:"Juridique", graphisme:"Graphisme", boutique:"Boutique", dons:"Dons", pack_fondateur:"Pack fondateur", merch:"Merch", divers:"Divers" };

export const DOC_STATUTS = { avance:"Avancé", rembourse:"Remboursé", a_rembourser:"À rembourser" };

export const DOC_RECURRENCES = ["ponctuel","hebdomadaire","mensuel","trimestriel","semestriel","annuel"];

export const REC_LABELS = { ponctuel:"Ponctuel", hebdomadaire:"Hebdomadaire", mensuel:"Mensuel", trimestriel:"Trimestriel", semestriel:"Semestriel", annuel:"Annuel" };

// Facteur de conversion vers un coût MENSUEL (pour la projection budgétaire)
export const REC_MONTHLY = { ponctuel:0, hebdomadaire:52/12, mensuel:1, trimestriel:1/3, semestriel:1/6, annuel:1/12 };

export const DOC_FILE_CATEGORIES = ["lore","contrat","patchnote","modelisation","map_custom","graphisme","juridique","facture_recu","reunion_cr","technique_infra","divers"];

export const DOC_FILE_CAT_LABELS = { lore:"Lore", contrat:"Contrat", patchnote:"Patch note", modelisation:"Modélisation", map_custom:"Map custom", graphisme:"Graphisme", juridique:"Juridique", facture_recu:"Facture / reçu", reunion_cr:"Réunion / CR", technique_infra:"Technique / infra", divers:"Divers" };
